import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import {
  getDepartmentQueryOptions,
  getDepartmentsQueryOptions,
} from "./get.hooks";

export function useDeleteDepartment(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/departments/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getDepartmentsQueryOptions.queryKey, (old) =>
        old?.filter((d) => d.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getDepartmentQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.departmentDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteDepartmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
